import { render, staticRenderFns } from "./EditTrain.vue?vue&type=template&id=1ea1e4fa&scoped=true"
import script from "./EditTrain.vue?vue&type=script&lang=js"
export * from "./EditTrain.vue?vue&type=script&lang=js"
import style0 from "./EditTrain.vue?vue&type=style&index=0&id=1ea1e4fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea1e4fa",
  null
  
)

export default component.exports